import {FAILURE, CHILDSUCCESS} from '../../constants'
import {getEntityChild as getEntityChildAPI} from '../../../services/entities'

export async function getEntityChildData(params, dispatch) {
  try {
    const response = await getEntityChildAPI(params)
    dispatch({type: CHILDSUCCESS, payload: response})
  } catch (e) {
    console.log(`Get Entities Failed: ${e}`)
    dispatch({type: FAILURE, payload: e})
  }
}
